import { useTokenReferralTracking } from '@/hooks/useTokenReferralTracking';
import { ReactNode } from 'react';

interface ReferralTrackingWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper component that automatically handles referral URL tracking
 * Should be placed inside Router context but outside route components
 */
export function ReferralTrackingWrapper({ children }: ReferralTrackingWrapperProps) {
  // This hook will automatically track referral URLs and page views
  useTokenReferralTracking();
  
  return <>{children}</>;
}